import { ACTIVITY_FEED_PATH } from './modules/activityFeed/activityFeed.repository';

const SELF_HANDLED_FORBIDDEN_PATHS: string[] = [ACTIVITY_FEED_PATH];

export const isSelfHandledForbidden = (url?: string) => {
  if (!url) {
    return false;
  }

  const path = url.replace(/^\//, '');

  return SELF_HANDLED_FORBIDDEN_PATHS.some((selfHandledPath) => path.startsWith(selfHandledPath));
};
